// SMART DEMO — Luna Beauty Studio asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (14 binary):
//   1 logo + 4 laser + 3 skincare + 4 microblading + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Luna Beauty Studio" tamamen kurgu demo markadır.

export const LUNA_BEAUTY_ASSET_ROOT = "/demo-presets/beauty/luna-beauty";

export interface LunaBeautyManifest {
  logo: string;
  laser: string[];
  skincare: string[];
  microblading: string[];
  videos: string[];
}

export const LUNA_BEAUTY_MANIFEST: LunaBeautyManifest = {
  logo: `${LUNA_BEAUTY_ASSET_ROOT}/logo/logo.webp`,
  laser: [
    `${LUNA_BEAUTY_ASSET_ROOT}/laser/01.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/laser/02.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/laser/03.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/laser/04.webp`,
  ],
  skincare: [
    `${LUNA_BEAUTY_ASSET_ROOT}/skincare/01.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/skincare/02.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/skincare/03.webp`,
  ],
  microblading: [
    `${LUNA_BEAUTY_ASSET_ROOT}/microblading/01.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/microblading/02.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/microblading/03.webp`,
    `${LUNA_BEAUTY_ASSET_ROOT}/microblading/04.webp`,
  ],
  videos: [
    `${LUNA_BEAUTY_ASSET_ROOT}/videos/01.mp4`,
    `${LUNA_BEAUTY_ASSET_ROOT}/videos/02.mp4`,
  ],
};